// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"101":"eb6c1be2","384":"32df27e2"}[chunkId] + ".chunk.css";
};